<template>
	<div class="nodeSpeed">
		<monitorHead title="网站测速" v-if="showTop"></monitorHead>
		<div class="progress_body">
			<div class="progress_item" v-for="(item, index) in list">
				<div class="progress_top">
					<span class="progress_left">{{ item.label }}</span>
					<span class="progress_right">{{ item.value }}</span>
				</div>
				<el-progress
					:percentage="item.percentage"
					:show-text="false"
					:color="item.color"
					:stroke-width="12"
				></el-progress>
			</div>
		</div>
		<div class="rules">
			<div class="rule_item" v-for="item in tagList">
				<div class="tag" :style="`backgroundColor: ${item.color}`"></div>
				<span>{{ item.label }}</span>
			</div>
		</div>
		<div class="tips">数据来自：GTmetrix（Google测速工具）</div>
	</div>
</template>

<script>
import monitorHead from './monitorHead';

export default {
	name: 'nodeSpeed',
	props: {
		details: Object,
		showTop: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		monitorHead,
	},
	data() {
		return {
			city: {
				2: '英国伦敦',
				3: '澳大利亚悉尼',
				4: '美国达拉斯',
				5: '印度孟买',
				6: '巴西圣保罗',
				7: '中国香港',
			},
			tagList: [
				{
					label: '0~2.9s',
					color: '#43B58E',
				},
				{
					label: '3~6s',
					color: '#FCE06C',
				},
				{
					label: '6s+',
					color: '#ED4F28',
				},
			],
		};
	},
	computed: {
		list(self) {
			let { details, city } = self;
			let { nodeTimeList } = details;
			let mapList = [];
			if (!nodeTimeList) nodeTimeList = [];
			Object.keys(city).map(key => {
				let obj = nodeTimeList.find(item => {
					return item.locationId == key;
				});
				if (obj) {
					let { fullyLoadedTime } = obj;
					let time = (fullyLoadedTime / 1000).toFixed(1);
					let color = '';
					let percentage = ((time / 6) * 100).toFixed(0) - 0;
					if (time >= 0 && time < 3) color = '#43B58E';
					else if (time >= 3 && time < 6) color = '#FCE06C';
					else if (time >= 6) color = '#ED4F28';
					mapList.push({
						label: city[key],
						color,
						percentage: percentage > 100 ? 100 : percentage,
						value: fullyLoadedTime ? `${time}s` : '暂无数据',
					});
				} else {
					mapList.push({
						label: city[key],
						color: '#ED4F28',
						percentage: 100,
						value: '+10s',
					});
				}
			});
			return mapList;
		},
	},
};
</script>

<style lang="scss" scoped>
.nodeSpeed {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	margin-bottom: 10px;
	padding: 0 100px 50px;

	.monitorHead {
		padding-bottom: 0 !important;
		border-bottom: none !important;
	}

	.progress_body {
		display: grid;
		grid-template-columns: repeat(3, 30%);
		justify-content: space-between;
		grid-row-gap: 40px;
	}

	.progress_item {
		.progress_top {
			display: flex;
			justify-content: space-between;
			margin-bottom: 10px;
			font-size: 16px;
			font-weight: 500;
			color: #333333;

			.progress_right {
				font-weight: 400;
			}
		}
	}

	.tips {
		text-align: right;
		margin-top: 20px;
		font-size: 16px;
		font-weight: 400;
		color: #999999;
	}

	.rules {
		display: flex;
		margin-top: 30px;
		width: 100%;
		justify-content: center;

		.rule_item {
			// flex: 1;
			// width: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0 10px;
			font-size: 12px;

			.tag {
				width: 20px;
				height: 20px;
				background-color: red;
				margin-right: 10px;
			}
		}
	}
}
</style>
